import type { FC, ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { ChevronLeftIcon } from '@dhl-ui/icons'
import { Button, H6 } from '@dhl-ui/components'

type Props = {
  children: ReactNode
  onClick?: () => void
  to?: string
}

export const BackButton: FC<Props> = ({ children, onClick, to }) => {
  const props = to ? { to, component: Link } : { onClick }

  return (
    <Button startIcon={<ChevronLeftIcon />} variant="text" color="primary" data-test-id="back" {...props}>
      <H6>{children}</H6>
    </Button>
  )
}
